export const deselectOptions = (selector) => {
    const currentSelection = selector.querySelector('li.selected');

    if (!currentSelection) {
        return;
    }

    currentSelection.classList.remove('selected');
};

const selectOption = (option) => {
    option.classList.add('selected');

    option.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
    });
};

export const handleMouseNavigation = (selector, event) => {
    const option = event.target.closest('li');

    if (!option) {
        return;
    }

    option.classList.add('selected');
};

export const handleArrowNavigation = (selector, event) => {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
        return;
    }

    const currentSelection = selector.querySelector('li.selected');

    const previousOption =  selector.querySelector('li:not(.hidden):has(+ li.selected)');
    const nextOption     =  selector.querySelector('li.selected ~ li:not(.hidden)');

    const firstOption = selector.querySelector('li:not(.hidden)');
    const lastOption  = selector.querySelector('li:nth-last-child(1 of :not(.hidden))');

    deselectOptions(selector);

    if (event.key === 'ArrowDown' && currentSelection === null) {
        selectOption(firstOption);
    } else if (event.key === 'ArrowDown' && currentSelection === lastOption) {
        selectOption(firstOption);
    } else if (event.key === 'ArrowDown' && nextOption === null) {
        selectOption(firstOption);
    } else if (event.key === 'ArrowDown') {
        selectOption(nextOption);
    }

    if (event.key === 'ArrowUp' && currentSelection === null) {
        selectOption(lastOption);
    } else if (event.key === 'ArrowUp' && currentSelection === firstOption) {
        selectOption(lastOption);
    } else if (event.key === 'ArrowUp' && previousOption === null) {
        selectOption(lastOption);
    } else if (event.key === 'ArrowUp') {
        selectOption(previousOption);
    }
};
